import { APP_STARTED, INITIALIZE_AUTH } from './ActionTypes';
export const startApp = () => ({
  type: APP_STARTED
});
export const initializeAuth = ({
  user,
  enabledGates
}) => ({
  type: INITIALIZE_AUTH,
  user,
  enabledGates
});